// « À traiter par l'agent » : la ferme d'agents, ou un projet de la tour de
// contrôle (le retour part à son tri, l'équipe crée ensuite le ticket). Les
// projets viennent de l'API à l'ouverture, jamais d'une liste figée ici.
import type { JSX } from 'preact'
import { useRef, useState } from 'preact/hooks'
import type { FeedbackItem, TowerTarget } from '@feedbaacks/sdk'
import { useFeedbaacks } from '../context'
import { Bot, Send } from '../icons'
import { IconButton, useDismiss } from '../primitives'

export function AgentRoute({ item, onApprove, onTower }: {
  item: FeedbackItem
  onApprove: (approved: boolean) => void
  onTower: (project: string) => void
}): JSX.Element {
  const { client, t } = useFeedbaacks()
  const [open, setOpen] = useState(false)
  const [projects, setProjects] = useState<TowerTarget[] | null>(null)
  const ref = useRef<HTMLSpanElement>(null)
  useDismiss(open, () => setOpen(false), ref)

  const toggle = () => {
    setOpen((v) => !v)
    if (projects === null) client.feedback.towerProjects().then(setProjects, () => setProjects([]))
  }
  const pick = (run: () => void) => {
    setOpen(false)
    run()
  }

  return (
    <span class="fb-menu" ref={ref}>
      <IconButton label={t(item.agent_approved ? 'agent_approval_remove' : 'agent_approval_set')} active={item.agent_approved} testId="feedbaacks-row-agent" onClick={toggle}>
        <Bot size={12} />
      </IconButton>
      {open && (
        <div class="fb-menu-list" role="menu" aria-label={t('agent_route_title')}>
          <div class="fb-section-title">{t('agent_route_title')}</div>
          <button type="button" role="menuitem" class="fb-menu-item" onClick={() => pick(() => onApprove(!item.agent_approved))}>
            <Bot size={12} />
            {item.agent_approved ? t('agent_approval_remove') : t('agent_route_farm')}
          </button>
          {!!projects?.length && <div class="fb-section-title">{t('agent_route_tower')}</div>}
          {projects?.map((p) => (
            <button key={p.key} type="button" role="menuitem" class="fb-menu-item" onClick={() => pick(() => onTower(p.key))}>
              <Send size={12} />
              {p.label}
            </button>
          ))}
        </div>
      )}
    </span>
  )
}
